import ContactForm from './ContactForm'
import ContactInfo from './ContactInfo'

const ContactSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900">BİZE ULAŞIN</h1>
          <p className="mt-4 text-gray-600">
            Sorularınız ve Görüşleriniz İçin Aşağıdaki Formu Kullanarak Bizimle İletişime Geçebilirsiniz.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <ContactForm />
          <ContactInfo />
        </div>
      </div>
    </section>
  )
}

export default ContactSection